import { render } from "./CustomAlert.vue?vue&type=template&id=1fdbe9f8&scoped=true&ts=true"
import script from "./CustomAlert.vue?vue&type=script&lang=ts"
export * from "./CustomAlert.vue?vue&type=script&lang=ts"

import "./CustomAlert.vue?vue&type=style&index=0&id=1fdbe9f8&lang=scss&scoped=true"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdbe9f8"]])

export default __exports__